class FamiliaProductoTraduccion
{
  idFamiliaProductoTraduccion = 0;
  descripcion = null;
  caracteristicasGenerales = null;
  hojaTecnica = undefined;
  hojaSeguridad = undefined;
  idiomas_idIdioma = 0;
  familiaProducto_idFamiliaProducto = 0;
  idioma = null;

  constructor(obj = {}) {
    Object.assign(this, obj);
  }
}

module.exports = FamiliaProductoTraduccion;
